"use strict";

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function now() {
  if (typeof window === 'undefined' || !('performance' in window)) {
    return Date.now();
  }

  return performance.now();
}

exports["default"] = now;